import React, {useContext, useCallback, useState} from 'react';
import {StateContext} from '../App';
import './GameOver.scss';
import ReactGA from 'react-ga';
import {useDispatch} from 'react-redux';
import {Button} from '@material-ui/core';
import ReplayIcon from '@material-ui/icons/Replay';
import AccessAlarmIcon from '@material-ui/icons/AccessAlarm';
import {resetGame} from '../actions/actions';

const TimeUp = () => {
    const stateContext = useContext(StateContext);
    const dispatch = useDispatch();

    const onPlayAgainClicked = useCallback((event) => {
        ReactGA.event({
            category: 'User',
            action: 'Play Again After Time Is Up',
        });
        dispatch(resetGame());
        // Reset the timer and start it again
        stateContext.reset();
        stateContext.startTimer();
    });

    return (
        <div className="game-over">
            <div className="game-over-content">
                <AccessAlarmIcon style={{fontSize: '120px', marginBottom: '20px'}} />
                <h1 className="game-over-title">Dang!</h1>
                <h2 className="game-over-message">Time's up for this level</h2>
                <div className="next-action">
                    <Button
                        className="share-btn"
                        variant="contained"
                        size="small"
                        color="secondary"
                        endIcon={<ReplayIcon />}
                        onClick={onPlayAgainClicked}
                    >
                        Try again
                    </Button>
                </div>
            </div>
        </div>
    );
};

export default TimeUp;
